if (!customElements.get('product-media-badge')) {
  customElements.define(
    'product-media-badge',
    class ProductMediaBadge extends HTMLElement {
      constructor() {
        super();
        this.mediaGallery = null;
        this.badgeText = '';
        this.badgeEnabled = false;
        this.variantChangeUnsubscriber = null;
      }

      connectedCallback() {
        // 查找media-gallery元素（可能在当前元素内部或外部）
        this.mediaGallery = this.querySelector('media-gallery') || document.querySelector('media-gallery');
        if (!this.mediaGallery) {
          // 如果找不到，延迟重试
          setTimeout(() => {
            this.mediaGallery = this.querySelector('media-gallery') || document.querySelector('media-gallery');
            if (this.mediaGallery) {
              this.initialize();
            }
          }, 100);
          return;
        }

        this.initialize();
      }

      initialize() {
        if (!this.mediaGallery) return;

        this.badgeEnabled = this.mediaGallery.dataset.enableBadge === 'true';
        // 从 media-gallery 或 ul 获取角标文字
        const badgeTextFromGallery = this.mediaGallery.dataset.badgeText;
        const mediaList = this.mediaGallery.querySelector('.product__media-list');
        const badgeTextFromUl = mediaList?.dataset.badgeText;
        
        // 如果 ul 没有 data-badge-text 属性，说明角标文字为空，不初始化
        if (badgeTextFromUl === undefined && badgeTextFromGallery === undefined) {
          console.log('Badge text is empty (no data-badge-text attribute), skipping initialization');
          return;
        }
        
        this.badgeText = badgeTextFromUl || badgeTextFromGallery || '';

        if (!this.badgeEnabled) {
          console.log('Media badge disabled by setting, skipping initialization');
          return;
        }

        console.log('Product Media Badge Initialized:', {
          badgeEnabled: this.badgeEnabled,
          badgeText: this.badgeText,
          badgeTextTrimmed: (this.badgeText || '').trim()
        });

        // 如果角标文字为空，不初始化
        if (!(this.badgeText || '').trim()) {
          console.log('Badge text is empty, skipping initialization');
          return;
        }

        // 监听变体切换事件
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.handleVariantChange(event);
          });
        }

        // 初始化角标显示状态 - 延迟执行，确保DOM完全加载
        setTimeout(() => {
          this.updateBadges();
        }, 300);

        // 也监听DOMContentLoaded，确保在页面完全加载后再次检查
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
              this.updateBadges();
            }, 100);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      handleVariantChange(event) {
        if (!event || !event.data) return;
        
        const variant = event.data.variant;
        
        if (this.badgeEnabled) {
          console.log('Variant Change Event:', { variant, eventData: event.data });
        }
        
        // 延迟更新，确保DOM已更新
        setTimeout(() => {
          this.updateBadges(variant);
        }, 200);
      }

      updateBadges(variant) {
        if (!this.badgeEnabled || !this.mediaGallery) return;

        // 查找 ul 标签（product__media-list）
        const mediaList = this.mediaGallery.querySelector('.product__media-list');
        if (!mediaList) {
          console.warn('Product Media Badge: mediaList not found');
          return;
        }

        // 从 ul 的 data 属性获取角标文字（如果存在）
        const badgeTextFromUl = mediaList.dataset.badgeText;
        // 检查是否有 data-badge-text 属性，如果没有说明角标文字为空
        if (badgeTextFromUl === undefined) {
          // 如果 ul 没有 data-badge-text 属性，说明角标文字为空，隐藏所有角标
          const mediaElements = this.mediaGallery.querySelectorAll('.product__media.media.media--transparent');
          mediaElements.forEach((mediaEl) => {
            const badge = mediaEl.querySelector('.product__media-badge');
            if (badge) {
              badge.classList.add('hidden');
              badge.style.cssText = 'display: none !important;';
            }
          });
          console.log('Badge text is empty (no data-badge-text attribute), hiding all badges');
          return;
        }
        
        if (badgeTextFromUl !== undefined) {
          this.badgeText = badgeTextFromUl;
        }

        // 检查角标文字是否为空，如果为空则不显示角标
        const badgeTextTrimmed = (this.badgeText || '').trim();
        if (!badgeTextTrimmed) {
          // 如果角标文字为空，隐藏所有角标
          const mediaElements = this.mediaGallery.querySelectorAll('.product__media.media.media--transparent');
          mediaElements.forEach((mediaEl) => {
            const badge = mediaEl.querySelector('.product__media-badge');
            if (badge) {
              badge.classList.add('hidden');
              badge.style.cssText = 'display: none !important;';
            }
          });
          console.log('Badge text is empty, hiding all badges');
          return;
        }

        // 如果没有传入variant，尝试从表单获取当前选中的变体
        if (!variant) {
          variant = this.getCurrentVariant();
        }

        // 如果还是没有variant，尝试从data-selected-variant获取
        if (!variant) {
          const selectedVariantEl = document.querySelector('variant-selects [data-selected-variant]');
          if (selectedVariantEl) {
            try {
              variant = JSON.parse(selectedVariantEl.innerHTML);
            } catch (e) {
              console.warn('Product Media Badge: Failed to parse selected variant', e);
            }
          }
        }

        const shouldShowBadge = this.shouldShowBadge(variant);
        
        // 调试日志
        console.log('Update Badges:', {
          variant,
          shouldShowBadge,
          badgeEnabled: this.badgeEnabled,
          variantOption1: variant?.option1,
          variantOption2: variant?.option2,
          variantOption3: variant?.option3,
          variantOptions: variant?.options
        });
        
        // 查找所有 product__media media media--transparent 元素
        const mediaElements = this.mediaGallery.querySelectorAll('.product__media.media.media--transparent');
        
        mediaElements.forEach((mediaEl) => {
          // 查找或创建角标（应该在 product__media media media--transparent 元素内）
          let badge = mediaEl.querySelector('.product__media-badge');
          
          // 如果角标不存在，创建一个
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'product__media-badge';
            badge.textContent = badgeTextTrimmed;
            // 将角标插入到 mediaEl 的第一个位置
            mediaEl.insertBefore(badge, mediaEl.firstChild);
          } else {
            // 更新角标文字（如果从 data 属性获取到了新的文字）
            if (badgeTextFromUl !== undefined) {
              badge.textContent = badgeTextTrimmed;
            }
          }
          
          // 显示或隐藏角标 - 使用更强制的方式
          if (shouldShowBadge) {
            // 先移除 hidden 类名（必须在设置样式之前）
            badge.classList.remove('hidden');
            
            // 移除所有内联样式，然后重新设置
            badge.removeAttribute('style');
            
            // 使用 setAttribute 直接设置 style，确保优先级
            badge.setAttribute('style', 'display: block !important; visibility: visible !important; opacity: 1 !important;');
            
            // 也通过 style 对象设置（作为备用）
            badge.style.display = 'block';
            badge.style.visibility = 'visible';
            badge.style.opacity = '1';
          } else {
            // 隐藏时添加 hidden 类
            badge.classList.add('hidden');
            badge.style.cssText = 'display: none !important;';
          }
        });
        
        console.log(`Updated ${mediaElements.length} badges, shouldShowBadge: ${shouldShowBadge}`);
      }

      getCurrentVariant() {
        // 首先尝试从表单获取选项值
        const options = this.getCurrentVariantFromForm();
        if (options) return options;

        // 如果无法从表单获取，返回null
        return null;
      }

      shouldShowBadge() {
        return this.badgeEnabled && !!(this.badgeText || '').trim();
      }

      getCurrentVariantFromForm() {
        const options = {};
        
        // 方法1: 从 data-selected-value 元素读取（这些元素显示当前选中的值）
        const selectedValueElements = document.querySelectorAll('[data-selected-value]');
        console.log('Found data-selected-value elements:', selectedValueElements.length);
        
        selectedValueElements.forEach((el, index) => {
          // 获取文本内容（去除HTML标签）
          const text = el.textContent || el.innerText || '';
          const trimmedText = text.trim();
          
          // 找到这个元素所在的 product-form__input 容器
          const formInput = el.closest('.product-form__input');
          if (formInput) {
            // 尝试从 label 获取选项名称
            const label = formInput.querySelector('.form__label');
            const optionName = label ? label.textContent.trim() : '';
            
            // 选项位置通常是按顺序的（第一个选项是option1，第二个是option2，等等）
            const position = index + 1;
            
            if (trimmedText) {
              options[`option${position}`] = trimmedText;
              console.log(`From data-selected-value[${index}]: option${position} = "${trimmedText}" (from label: "${optionName}")`);
            }
          } else if (trimmedText) {
            // 如果没有找到 formInput，直接按索引分配
            const position = index + 1;
            options[`option${position}`] = trimmedText;
            console.log(`From data-selected-value[${index}]: option${position} = "${trimmedText}"`);
          }
        });
        
        // 方法2: 从选中的 radio input 的 label 读取
        const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
        checkedRadios.forEach((radio, index) => {
          const label = document.querySelector(`label[for="${radio.id}"]`);
          if (label) {
            const labelText = (label.textContent || label.innerText || '').trim();
            // 移除可能的 unavailable 文本
            const cleanText = labelText.replace(/\(.*unavailable.*\)/i, '').trim();
            
            if (cleanText) {
              const position = index + 1;
              // 如果这个位置还没有值，使用这个值
              if (!options[`option${position}`]) {
                options[`option${position}`] = cleanText;
                console.log(`From checked radio[${index}]: option${position} = "${cleanText}"`);
              }
            }
          }
        });
        
        // 方法3: 从选中的 button 或 swatch 读取
        const checkedButtons = document.querySelectorAll('input[type="radio"]:checked + label, input[type="radio"]:checked ~ label');
        checkedButtons.forEach((button, index) => {
          const buttonText = (button.textContent || button.innerText || '').trim();
          const cleanText = buttonText.replace(/\(.*unavailable.*\)/i, '').trim();
          
          if (cleanText && !Object.values(options).includes(cleanText)) {
            const position = Object.keys(options).length + 1;
            if (position <= 3) {
              options[`option${position}`] = cleanText;
              console.log(`From checked button[${index}]: option${position} = "${cleanText}"`);
            }
          }
        });
        
        // 方法4: 从 variant-selects 中查找所有 product-form__input，按顺序读取
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          const formInputs = variantSelects.querySelectorAll('.product-form__input');
          formInputs.forEach((formInput, index) => {
            const position = index + 1;
            
            // 优先从 data-selected-value 读取
            const selectedValue = formInput.querySelector('[data-selected-value]');
            if (selectedValue) {
              const text = (selectedValue.textContent || selectedValue.innerText || '').trim();
              if (text && !options[`option${position}`]) {
                options[`option${position}`] = text;
                console.log(`From formInput[${index}].data-selected-value: option${position} = "${text}"`);
              }
            }
            
            // 如果没有 data-selected-value，从选中的 input 的 value 读取
            if (!options[`option${position}`]) {
              const checkedInput = formInput.querySelector('input[type="radio"]:checked');
              if (checkedInput && checkedInput.value) {
                options[`option${position}`] = checkedInput.value.trim();
                console.log(`From formInput[${index}].checkedInput: option${position} = "${checkedInput.value}"`);
              }
            }
          });
        }

        const result = {
          option1: options.option1 || '',
          option2: options.option2 || '',
          option3: options.option3 || '',
        };

        console.log('Get Current Variant From Form (Final):', { 
          allOptions: options, 
          result,
          hasOption1: !!result.option1,
          hasOption2: !!result.option2,
          hasOption3: !!result.option3
        });

        return result;
      }
    }
  );
}

